module.exports = __webpack_public_path__ + "static/media/pause2.ec80e546.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/pause2.png
// module id = 2071
// module chunks = 6